// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import CountingBundleTotalRunningAvailability from '../shared/counting-bundle-total-running-availability';
import React from 'react';

function CountingBundleTotalAvailabilityPage () {

    return (
        <AuthenticatedPage className="atp-page atp-counting-bundle-total-availability-page">
            <CountingBundleTotalRunningAvailability bundleAvailability={false} />
        </AuthenticatedPage>
    );

}
CountingBundleTotalAvailabilityPage.displayNAme = 'CountingBundleTotalAvailabilityPage';

export default CountingBundleTotalAvailabilityPage;
